// Zustand store for User and Auth Details
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
  email: null,
  trial_id: null,
  customer_id: null,
  stripe_customer_id: null,
  client_secret: null,
  setup_intent_id: null,
  first_name: null,
  last_name: null,
  phone: null,
  password: null,
  payment_method_id: null,
};

// Sample user object
const useTrialStore = create(
  devtools(
    (set) => ({
      ...initialState,
      setTrialUserDetails: (details) =>
        set({
          email: details.email,
          trial_id: details.trial_id,
          customer_id: details.customer_id,
          stripe_customer_id: details.stripe_customer_id,
          client_secret: details.client_secret,
          setup_intent_id: details.setup_intent_id,
        }),
      setSetupIntentId: (setupIntentId) =>
        set({ setup_intent_id: setupIntentId }),
      resetTrialUserDetails: () => set(initialState),
    }),
    { name: 'trialStore' }
  )
);

export default useTrialStore;
